import { Edit } from "lucide-react";
import { useEffect, useState } from "react";
import { Button } from "@/shared/components/ui/button";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
} from "@/shared/components/ui/dialog";
import t from "@/lang/lang";
import { CommonDialogFooter } from "@/shared/components/ui/dialog-common";
import { RoleSelect } from "@/shared/lib/authorization/dev-context-provider";
import { RTKQueryErrorAlert } from "@/shared/components/domain/errors/rtk-query-error-alert";
import {
  PutRequest,
  useAuthFeatureAuthPutMutation,
} from "../services/feature-auth";
import { FeatureAuthRule } from "../types/feature-auth-rules";

export function FeatureAuthEditDialog({ rule }: { rule: FeatureAuthRule }) {
  const [open, setOpen] = useState(false);
  const [request, setRequest] = useState<PutRequest>(rule);
  const [put, { isLoading, error, isSuccess, reset }] =
    useAuthFeatureAuthPutMutation();

  useEffect(() => {
    if (isSuccess) {
      reset();
      setOpen(false);
    }
  }, [isSuccess, reset]);

  const doUpdate = () => {
    if (isLoading) return;
    put(request);
  };

  console.log(request);

  return (
    <Dialog open={open} onOpenChange={setOpen}>
      <DialogTrigger asChild>
        <Button size="sm" variant="outline">
          <Edit />
        </Button>
      </DialogTrigger>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>{t("Regel bearbeiten")}</DialogTitle>
          <DialogDescription>
            {t(
              "Hier könenn sie die Zugangsbeschränkungen bearbeiten. Wenn nichts ausgewählt ist, können alle Nutzer auf das Feature zugreifen.",
            )}
          </DialogDescription>
        </DialogHeader>
        <div className="grid gap-4">
          <RoleSelect
            roles={request.requirement.roles || []}
            onRolesChange={(roles) =>
              setRequest({
                ...request,
                requirement: {
                  ...request.requirement,
                  roles,
                },
              })
            }
          />
        </div>
        <RTKQueryErrorAlert error={error} />
        <CommonDialogFooter isLoading={isLoading} onClickAction={doUpdate} />
      </DialogContent>
    </Dialog>
  );
}
